import { useQuery } from "@tanstack/react-query"
import { useCurrentOrganization } from "@/modules/organizations/hooks/use-organizations"
import { resourceAccessService } from "../infrastructure/resource-access-service"
import { ResourceType } from "../dtos/ResourceAccessDtos"

const PAGE_SIZE = 20

/** Owner-only — the backend returns 403 for anyone else, matching AccessPanel's own gating. */
export function useResourceAssignmentAuditLog(type: ResourceType, resourceId: string, page: number) {
  const org = useCurrentOrganization()
  const orgId = org?.id ?? ""

  return useQuery({
    queryKey: ["resource-assignment-audit-log", orgId, type, resourceId, page],
    queryFn: () =>
      resourceAccessService.getAuditLog(orgId, { type, resourceId, page, pageSize: PAGE_SIZE }),
    enabled: !!orgId && !!resourceId,
  })
}
